import { render } from "./Values.vue?vue&type=template&id=40728fc0&ts=true"
import script from "./Values.vue?vue&type=script&lang=ts"
export * from "./Values.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__